import React from 'react';
import ContactDetails from '../components/ContactDetails';
import Footer from '../components/Footer';


const Contact = () => {
    return (
        <div>
            <ContactDetails />
            <Footer />
        </div>
    );
}

export default Contact